/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { createBanksCashAccounts, modifyCashAccountsInfo } from '../../../../apis/finances/bank';
import Form from '../../../../components/Form';
import Modal, { ModalHeader } from '../../../../components/Modal';
import useForm from '../../../../hooks/useForm';
import { viewLoading } from '../../../../utils/loading';

const CashAccount = ({ open, setOpen, mode, submit, data }) => {
  const [fields] = useState([
    [
      { title: '계좌명', key: 'name', type: 'input', required: true, }
    ],
    [
      { title: '계좌설명', key: 'memo', type: 'input' }
    ]
  ])

  useEffect(() => {
    setForm({
      name: data.name,
      memo: data.memo
    })
  }, [data])

  const _submit = (form) => {
    viewLoading(true)
    switch (mode) {
      case 'create':
        createBanksCashAccounts(form).then(() => { cancel(); submit(); }).catch(() => { }).finally(() => viewLoading(false))
        break;
      case 'modify':
        modifyCashAccountsInfo(data.idx, form).then(() => { cancel(); submit(); }).catch(() => { }).finally(() => viewLoading(false))
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    setValidateFields(fields)
  }, [fields])

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    originForm,
    setValidateFields
  } = useForm(
    {
      name: "",
      memo: "",
    },
    _submit,
  );

  const cancel = () => {
    setOpen(false)
    setForm(originForm)
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="cash-account-write">
        <ModalHeader>{mode === 'create' ? '새 기타거래 등록' : '기타거래 수정'}</ModalHeader>
        <Form
          fields={fields}
          errors={errors}
          form={form}
          onChange={handleOnChange}
          submit={handleSubmit}
          cancel={cancel}
          isRequiredShow
        />
      </div>
    </Modal>
  )
}

export default CashAccount;